/* unplugin-vue-components disabled */
import {ShTopics} from 'stores/sh-topics'

export default {
  mixins: [ModelValue(Array)],
  data() {
    return {
      loading: true,
      options: undefined,
      // we do not use default store here to allow this control to be used multiple times
      // on the same page or on another pages with the default store
      store: new ShTopics()
    }
  },
  async mounted() {
    if (this.value) {
      const options = []
      await this.store.load({ids: this.value})      
      for(const topic of this.store.view_items) {
        options.push({
          value: topic.id,
          label: topic.name
        })
      }
      this.options = options
    }
    this.loading = false
  },
  methods: {
    async searchShTopics(autocomplete) {
      await this.store.load({autocomplete, limit: 50})
      this.options = this.store.view_items.map(topic => {
        return {
          value: topic.id,
          label: topic.name
        }
      })
    }
  }
}
